import { Injectable } from '@angular/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { AppSettings } from '../enums/app-settings.enum';
import { UtilitiesService } from '../utilities/utilities.service';

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  private currency = AppSettings.LOCAL_CURRENTCY;
  constructor(
    private GTMS: GoogleTagManagerService,
    private UTS: UtilitiesService
  ) {}
  page(AT: string) {
    try{
      const language =
        this.UTS.getLocaleLanguage() &&
        this.UTS.getLocaleLanguage().toLowerCase() == 'en'
          ? ''
          : '-AR';
      const payload = {
        event: 'navigation',
        user_env: this.UTS.getENV(),
        eventCategory: 'navigation' + language,
        eventAction: 'add-ons-sections',
        eventLabel: 'add-ons',
        Link: AT || '',
      };
      this.pushDateOnGoogleAnalytics(payload);
      
    }catch(e){
      console.log(e);
    }
  }

  category(AT: string, SC: string) {
    try{
      const language =
        this.UTS.getLocaleLanguage() &&
        this.UTS.getLocaleLanguage().toLowerCase() == 'en'
          ? ''
          : '-AR';
      const payload = {
        event: 'navigation',
        user_env: this.UTS.getENV(),
        eventCategory: 'navigation' + language,
        eventAction: 'add-ons-sections',
        eventLabel: AT && AT.includes(' ') ? AT.split(' ').join('_') : AT,
        Link: SC || '',
      };
      this.pushDateOnGoogleAnalytics(payload);
  
    }catch(e){
      console.log(e);
    }
  }

  filter(F: string) {
    try{
      const language =
        this.UTS.getLocaleLanguage() &&
        this.UTS.getLocaleLanguage().toLowerCase() == 'en'
          ? ''
          : '-AR';
      const payload = {
        event: 'filter',
        user_env: this.UTS.getENV(),
        eventCategory: 'filter' + language,
        eventAction: 'click',
        eventLabel: F && F.includes(' ') ? F.split(' ').join('_') : F,
      };
      this.pushDateOnGoogleAnalytics(payload);
  
    }catch(e){
      console.log(e);
    }
  }

  productImpressions(impressions: any) {
    try{
      const payload = {
        event: 'productImpressions',
        user_env: this.UTS.getENV(),
        ecommerce: {
          currencyCode: this.currency  || '',
          impressions: impressions  || '',
        },
      };
      this.pushDateOnGoogleAnalytics(payload);
  
    }catch(e){
      console.log(e);
    }
  }
  addonsImpression(payload: any) {
    try{
  
      this.pushDateOnGoogleAnalytics(payload);
    }catch(e){
      console.log(e);
    }
  }

  productImpressionsOnSearch_Roaming(impressions)
  {
    try{
      this.pushDateOnGoogleAnalytics(impressions);
  
    }catch(e){
      console.log(e);
    }
  }
  productClick_RoamingType(payload)
  {
    try{
      this.pushDateOnGoogleAnalytics(payload);
  
    }catch(e){
      console.log(e);
    }
  }

  countrySearch_Roaming(payload)
  {
    try{
      this.pushDateOnGoogleAnalytics(payload);
  
    }catch(e){
      console.log(e);
    }
  }
  onTermsAndConditions_Roaming(payload)
  {
    try{
      
      this.pushDateOnGoogleAnalytics(payload);
    }catch(e){
      console.log(e);
    }
  }
  productClick(
    AT: string,
    SC: string,
    PN: string,
    PID: string,
    PP: string,
    I: number,
    B: string
  ) {
    try{
      AT = AT.includes(' ') ? AT.split(' ').join('_') : AT;
      const payload = {
        event: 'productClick',
        user_env: this.UTS.getENV(),
        ecommerce: {
          currencyCode:'AED',
          click: {
            actionField: {
              action:'click',
              list: `${AT}_Add_ons`, //String - Product List Name
            },
            products: [
              {
                name: PN  || '', //String - Product Name
                id: PID  || '', //String - Product ID
                price: PP || '', //String - Product Price
                brand: B || '', //String - Product Brand
                category: 'Add_ons', //String - Product Category
                dimension25: SC || '', //String - Category  (if available) Data or Combo or Roaming
                position: I, //Number - Position in the list
              },
            ],
          },
        },
      };
  
      this.pushDateOnGoogleAnalytics(payload);
  
    }catch(e){
      console.log(e);
    }
  }
  public onSubscribeSuccessAddon(event,AB,AC,AD,AK,AF,AG,AH,AI,AJ,AL,AZ){
    try{
      let userInfo = '';
      if (localStorage.getItem('USER_ID_PLAN_MIGRATION')) {
        userInfo = JSON.parse(localStorage.getItem('USER_ID_PLAN_MIGRATION'));
      }
      const payload = {
        event: event,
        ecommerce: {
          items: [
            {
              item_category: AB || '',
              item_list_name: AC || '',
              item_name: AD || '',
              item_brand: AK || '',
              item_list_id: AF || '',
              item_id: AG || '',
              item_extras: AH || '',
              device_type: AI || '',
              price: AJ || '',
              currency: AL || '',
              quantity: AZ || '',
              user_id: userInfo
            },
          ],
        }
      }
      this.pushDateOnGoogleAnalytics(payload);
  
    }catch(e){
      console.log(e);
    }
  }
  productDetailImpression(
    AT: string,
    SC: string,
    PN: string,
    PID: string,
    PP: string,
    B: string,
    P:any = ''
  ) {
    try{
      AT = AT && AT.includes(' ') ? AT.split(' ').join('_') : AT;
      const payload = {
        event: 'productDetailImpression',
        user_env: this.UTS.getENV(),
        ecommerce: {
          currencyCode:'AED',
          detail: {
            //Detail object
            actionField: {
              action:'detail',
              list: `${AT}_Add_ons`, //String - Product List Name
            }, // 'detail' actions have an optional list property. Pass from which list user have arrived to the detail page
            products: [
              {
                name: PN || '', //String - Product Name
                id: PID || '', //String - Product ID
                price: PP || '', //String - Product Price
                brand: B || '', //String - Product Brand
                category: 'Add_ons', //String - Product Category
                dimension25: SC || '', //String - Category  (if available) Data or Combo or Roaming
                position: P, //Number - Position in the list
              },
            ],
          },
        },
      };
      this.pushDateOnGoogleAnalytics(payload);
  
    }catch(e){
      console.log(e);
    }
  }

  addToCart(
    AT: string,
    SC: string,
    PN: string,
    PID: string,
    PP: string,
    I: number,
    B: string
  ) {
    try{
  
      AT = AT && AT.includes(' ') ? AT.split(' ').join('_') : AT;
      const payload = {
        event: 'addToCart',
        user_env: this.UTS.getENV(),
        ecommerce: {
          currencyCode: this.currency || '',
          add: {
            //Detail object
            actionField: {
              action:'add',
              list: `${AT}_Add_ons`, //String - Product List Name
            }, // 'detail' actions have an optional list property. Pass from which list user have arrived to the detail page
            products: [
              {
                name: PN || '', //String - Product Name
                id: PID || '', //String - Product ID
                price: PP ? Number(PP).toFixed(2): '', //String - Product Price
                brand: B || '', //String - Product Brand
                category: 'Add_ons', //String - Product Category
                dimension25: SC || '', //String - Category  (if available) Data or Combo or Roaming
                quantity: I || '', //Number - Position in the list
              },
            ],
          },
        },
      };
  
      this.pushDateOnGoogleAnalytics(payload);
    }catch(e){
      console.log(e);
    }
  }

  purchase(
    AT: string,
    SC: string,
    PN: string,
    PID: string,
    PP: string,
    I: number,
    B: string,
    TID: string,
    R: string,
    T?: string,
    S?: string,
    C?: string
  ) {
    try{
      const tax:any =  R ? Number(R) * 0.05 : '';
      const payload = {
        event: 'purchase',
        user_env: this.UTS.getENV(),
        
        ecommerce: {
          currencyCode: this.currency || '',
          purchase: {
            //Detail object
            actionField: {
              list: `${AT}_Add_ons`, //String - Product List Name
              id: TID || '', // Transaction ID. Required for purchases and refunds.
              affiliation: 'Online Store',
              revenue: R ? String(+R + tax) : '', // Total transaction value (incl. tax and shipping)
              tax: tax ? String(tax) : '',
              shipping: S ? S : '',
              coupon: C ? C : '',
            },
            products: [
              {
                name: PN || '', //String - Product Name
                id: PID || '', //String - Product ID
                price: PP ? Number(PP).toFixed(2): '', //String - Product Price
                brand: B || '', //String - Product Brand
                category: 'Add_ons', //String - Product Category
                dimension25: SC || '', //String - Category  (if available) Data or Combo or Roaming
                quantity: I, //Number - Position in the list
              },
            ],
          },
        },
      };
      this.pushDateOnGoogleAnalytics(payload);
  
    }catch(e){
      console.log(e);
    }
  }

  OTPVerification(EA: string, EL: string) {
    try{
      const language =
        this.UTS.getLocaleLanguage() &&
        this.UTS.getLocaleLanguage().toLowerCase() == 'en'
          ? ''
          : '-AR';
      const payload = {
        event: 'OTPVerification',
        eventCategory: 'OTPVerification' + language,
        eventLabel: (EA && EA !="")? EA.split(' ').join('_'): EA, //:  ‘submit or error-name of error’,
        eventAction: (EL && EL !="")? EL.split(' ').join('_'): EL,
        user_env: this.UTS.getENV(),
      };
      this.pushDateOnGoogleAnalytics(payload);
  
    }catch(e){
      console.log(e);
    }
  }

  private pushDateOnGoogleAnalytics(P: any) {
    try {
      this.GTMS.pushTag(P);
    } catch (e) {
      // this.UTS.error(e)
    }
  }
  sort( EA,PC) {
    try{
      const language =
        this.UTS.getLocaleLanguage() &&
        this.UTS.getLocaleLanguage().toLowerCase() == 'en'
          ? ''
          : '-AR';
      const payload = {
        event: 'b2c_events',
        user_env: this.UTS.getENV(),
        eventCategory: 'sort' + language,
        eventAction: EA || '',
        ProductCategory: PC || '',
      };
      this.pushDateOnGoogleAnalytics(payload);
  
    }catch(e){
      console.log(e);
    }
  }
  public onClickTabAddon(event,skuId,section) {
    try{
      let accountTP = '';
      let userInfo = '';
      if (localStorage.getItem('USER_ID_PLAN_MIGRATION')) {
        userInfo = JSON.parse(localStorage.getItem('USER_ID_PLAN_MIGRATION'));
      }
      if (sessionStorage.getItem("currentUserAccountType")) {
        accountTP = sessionStorage.getItem("currentUserAccountType");
      }
      let payload = {
        event: event,
        entry_point: window.location.pathname || '', //Dynamic Values
        section: section || '', // Dynamic Value ex: Data boosters etc
        current_Account_type: accountTP || '', // Dynamic Value ex : Postpaid/VL/CL
        user_id: userInfo || '', // No pii data
        language: this.UTS.getLocaleLanguage() &&
          this.UTS.getLocaleLanguage().toLowerCase() == 'en'
          ? ''
          : 'AR',
        sku_id: skuId || '', // Capture the SKU Id
        device_type: this.UTS.getENV() || ''
      }
      this.pushDateOnGoogleAnalytics(payload);
  
    }catch(e){
      console.log(e);
    }
  }
  public onClickDetailsButton(event,name,details,skuId) {
    try{
      let accountTP = '';
      let userInfo = '';
      if (localStorage.getItem('USER_ID_PLAN_MIGRATION')) {
        userInfo = JSON.parse(localStorage.getItem('USER_ID_PLAN_MIGRATION'));
      }
      if (sessionStorage.getItem("currentUserAccountType")) {
        accountTP = sessionStorage.getItem("currentUserAccountType");
      }
      let payload = {
        event: event,
        entry_point: window.location.pathname || '', //Dynamic Values
        section: name, // Dynamic Value ex: Data boosters etc
        sub_section : details,
        current_Account_type: accountTP, // Dynamic Value ex : Postpaid/VL/CL
        user_id: userInfo, // No pii data
        language: this.UTS.getLocaleLanguage() &&
          this.UTS.getLocaleLanguage().toLowerCase() == 'en'
          ? ''
          : 'AR',
        sku_id: skuId, // Capture the SKU Id
        device_type: 'Web'
      }
      this.pushDateOnGoogleAnalytics(payload);
  
    }catch(e){
      console.log(e);
    }
  }
  public onClickDetailsAddon(event,section,sub_section,error,user,otp,skuId) {
    try{
      let accountTP = '';
      let userInfo = '';
      if (localStorage.getItem('USER_ID_PLAN_MIGRATION')) {
        userInfo = JSON.parse(localStorage.getItem('USER_ID_PLAN_MIGRATION'));
      }
      if (sessionStorage.getItem("currentUserAccountType")) {
        accountTP = sessionStorage.getItem("currentUserAccountType");
      }
      let payload = {
        event: event || '',
        entry_point: window.location.pathname || '', //Dynamic Values
        section: section || '', // Dynamic Value ex: Data boosters etc
        sub_section : sub_section || '',
        error_message: error || '',
        current_Account_type: accountTP || '', // Dynamic Value ex : Postpaid/VL/CL
        user_type: user || '', // guest
        login_type:otp || '',
        user_id: userInfo || '', // No pii data
        language: this.UTS.getLocaleLanguage() &&
          this.UTS.getLocaleLanguage().toLowerCase() == 'en'
          ? ''
          : 'AR',
        sku_id: skuId || '', // Capture the SKU Id
        device_type: 'Web'
      }
      this.pushDateOnGoogleAnalytics(payload);
  
    }catch(e){
      console.log(e);
    }
  }
  public onClickVerify(event,name,skuId,login,otpStatus) {
    try{
      let accountTP = '';
      let userInfo = '';
      if (localStorage.getItem('USER_ID_PLAN_MIGRATION')) {
        userInfo = JSON.parse(localStorage.getItem('USER_ID_PLAN_MIGRATION'));
      }
      if (sessionStorage.getItem("currentUserAccountType")) {
        accountTP = sessionStorage.getItem("currentUserAccountType");
      }
      let payload = {
        event: event,
        entry_point: window.location.pathname || '', //Dynamic Values
        section: name, // Dynamic Value ex: Data boosters etc
        current_Account_type: accountTP, // Dynamic Value ex : Postpaid/VL/CL
        user_type: login, // guest
        login_type: otpStatus, // uae pass,
        user_id: userInfo, // No pii data
        language: this.UTS.getLocaleLanguage() &&
          this.UTS.getLocaleLanguage().toLowerCase() == 'en'
          ? ''
          : 'AR',
        sku_id: skuId, // Capture the SKU Id
        device_type: 'Web'
      }
      this.pushDateOnGoogleAnalytics(payload);
  
    }catch(e){
      console.log(e);
    }
  }
  public onSubscribeFail(event,name,skuId,login,otpStatus) {
    try{
      let accountTP = '';
      let userInfo = '';
      if (localStorage.getItem('USER_ID_PLAN_MIGRATION')) {
        userInfo = JSON.parse(localStorage.getItem('USER_ID_PLAN_MIGRATION'));
      }
      if (sessionStorage.getItem("currentUserAccountType")) {
        accountTP = sessionStorage.getItem("currentUserAccountType");
      }
      let payload = {
        event: event,
        entry_point: window.location.pathname || '', //Dynamic Values
        section: name, // Dynamic Value ex: Data boosters etc
        current_Account_type: accountTP, // Dynamic Value ex : Postpaid/VL/CL
        user_type: login, // guest
        login_type: otpStatus, // uae pass,
        user_id: userInfo, // No pii data
        language: this.UTS.getLocaleLanguage() &&
          this.UTS.getLocaleLanguage().toLowerCase() == 'en'
          ? ''
          : 'AR',
        sku_id: skuId, // Capture the SKU Id
        device_type: 'Web'
      }
      this.pushDateOnGoogleAnalytics(payload);
  
    }catch(e){
      console.log(e);
    }
  }
  public AddonsCardTracking(event,section,sub_section) {
    try {
      let userInfo = '';
      let userAccountType = '';
      let planName = '';
      if (sessionStorage?.getItem('planName')) {
        planName = sessionStorage.getItem('planName');
      }
      if (localStorage?.getItem('currentUserAccountType')) {
        userAccountType = localStorage.getItem('currentUserAccountType');
      }
      if (localStorage?.getItem('USER_ID_PLAN_MIGRATION')) {
        userInfo = JSON?.parse(localStorage?.getItem('USER_ID_PLAN_MIGRATION'));
      }
      let payload = {
        event: event,
        entry_point: window?.location?.pathname || '', //Dynamic Values
        section: section || '', // Dynamic Value ex: Data boosters etc
        sub_section: sub_section || '',
        current_account_type: userAccountType || '', // Dynamic Value ex : Postpaid/VL/CL
        current_plan_name: planName || '', // Dynamic Value ex : Postpaid/VL/CL
        user_id: userInfo || '', // No pii data
        language: this.UTS.getLocaleLanguage() &&
          this.UTS.getLocaleLanguage().toLowerCase() == 'en'
          ? 'EN'
          : 'AR',
        device_type: this.UTS.getENV()
      }
      this.pushDateOnGoogleAnalytics(payload);

    } catch (e) {
      console.log(e);
    }
  }
  public AddonsCardTrackingGA(event,section,sub_section,info,info1,sku_id,tenure,price) {
    try {
      let userInfo = '';
      let userAccountType = '';
      let planName = '';
      if (sessionStorage?.getItem('planName')) {
        planName = sessionStorage.getItem('planName');
      }
      if (localStorage?.getItem('currentUserAccountType')) {
        userAccountType = localStorage.getItem('currentUserAccountType');
      }
      if (localStorage?.getItem('USER_ID_PLAN_MIGRATION')) {
        userInfo = JSON?.parse(localStorage?.getItem('USER_ID_PLAN_MIGRATION'));
      }
      let payload = {
        event: event,
        entry_point: window?.location?.pathname || '', //Dynamic Values
        section: section || '', // Dynamic Value ex: Data boosters etc
        sub_section: sub_section || '',
        current_account_type: userAccountType || '', // Dynamic Value ex : Postpaid/VL/CL
        current_plan_name: planName || '', // Dynamic Value ex : Postpaid/VL/CL
        user_id: userInfo || '', // No pii data
        info: info || '', // No pii data
        info1: info1 || '', // No pii data
        sku_id: sku_id || '', // No pii data
        tenure: tenure || '', // No pii data
        language: this.UTS.getLocaleLanguage() &&
          this.UTS.getLocaleLanguage().toLowerCase() == 'en'
          ? 'en'
          : 'AR',
        device_type: this.UTS.getENV()
      }
      if(event = 'addons_promo_click')
      {
        payload['price'] = price;
      }
      this.pushDateOnGoogleAnalytics(payload);

    } catch (e) {
      console.log(e);
    }
  }
}
